const ZERO_TAX_VALUE = '0.00';

export {ZERO_TAX_VALUE};
